<h2 mat-dialog-title>{{ headerText() }}</h2>
<mat-dialog-content>
  {{ data.itemType }} <span class="name">{{ data.name }}</span> {{ "really_delete" | transloco }}
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    (click)="abort()"
    cdkFocusInitial
  >{{ "no" | transloco }}</button>
  <button
    mat-raised-button
    (click)="deleteEntry()"
  >{{ "yes" | transloco }}</button>
</mat-dialog-actions>